import { render, staticRenderFns } from "./Deregister.vue?vue&type=template&id=65a1a9d2&scoped=true&"
import script from "./Deregister.vue?vue&type=script&lang=js&"
export * from "./Deregister.vue?vue&type=script&lang=js&"
import style0 from "./Deregister.vue?vue&type=style&index=0&id=65a1a9d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a1a9d2",
  null
  
)

export default component.exports